import { FC, useState } from 'react';
import Text, { TextColor, TextVariant } from 'src/components/atoms/Text';
import Modal, { ModalVariant } from 'src/components/organisms/Modal';
import ListCheckNoteField from './ListCheckNoteField';
import { listCheckCopy } from './listCheckCopy';

interface DisagreeModalProps {
  ruled: string;
  isLoading: boolean;
  onConfirm: (note: string) => void;
  onCancel: () => void;
}

const DisagreeModal: FC<DisagreeModalProps> = ({ ruled, isLoading, onConfirm, onCancel }) => {
  const [note, setNote] = useState('');
  return (
    <Modal
      title={listCheckCopy.disagreeModalTitle}
      showModal
      variant={ModalVariant.danger}
      labelButtonConfirm={listCheckCopy.disagreeModalConfirm(ruled)}
      labelButtonCancel={listCheckCopy.modalCancel}
      isLoadingButtonConfirm={isLoading}
      isDisabledButtonConfirm={isLoading || !note.trim()}
      isDisabledButtonCancel={isLoading}
      isBackClosable={!isLoading}
      onConfirm={() => onConfirm(note.trim())}
      onCancel={onCancel}
      data-testid="fraud-trend-disagree-modal"
    >
      <Text color={TextColor.gray600} variant={TextVariant.normal}>
        {listCheckCopy.disagreeModalLead(ruled)}
      </Text>
      <ListCheckNoteField label={listCheckCopy.disagreeNoteLabel} value={note} onChange={setNote} />
    </Modal>
  );
};

export default DisagreeModal;
